import {z} from 'zod';

export const PostLikeResponse = z.object({
  likeCount: z.number(),
});

export const DeleteLikeResponse = z.object({
  likeCount: z.number(),
});

export const Industry = z.object({
  id: z.number(),
  name: z.string(),
});

export const BoxTagSchema = z.object({
  id: z.number(),
  name: z.string(),
});

export const BoxTagsResponseSchema = z.object({
  tags: z.array(BoxTagSchema),
});

export const NextURLParam = z.object({
  page: z.number(),
  perPage: z.number(),
});
export const Hashtag = z.object({
  id: z.number(),
  name: z.string(),
});

export const Question = z.object({
  id: z.number(),
  body: z.string(),
  hashtags: z.array(Hashtag),
  createdAt: z.string(),
});

export const PostQuestionResponse = z.object({
  id: z.number(),
});

export const PostQuestionNonDisplayResponse = z.string();

export const PostQuestionDTO = z.object({
  body: z.string(),
  isOpenQuestion: z.boolean(),
  hashTags: z.array(z.number()),
  adviserIDs: z.array(z.number()),
});

export const Answer = z.object({
  id: z.number(),
  body: z.string(),
  answeredAt: z.string(),
  liked: z.boolean(),
  likeCount: z.number(),
});

export const PostAnswerResponse = z.object({
  answerID: z.number(),
});

export const PostAnswerDTO = z.object({
  body: z.string(),
});

export const Adviser = z.object({
  id: z.number(),
  userName: z.string(),
  displayName: z.string(),
  iconImageURL: z.string(),
  introduction: z.string(),
  isInactivated: z.boolean(),
});

export const ListedAdviser = z.object({
  id: z.number(),
  userName: z.string(),
  displayName: z.string(),
  workingAt: z.string(),
  offeredBy: z.string(),
  introduction: z.string(),
  isStudent: z.boolean(),
  iconImageURL: z.string(),
  createdAt: z.string(),
  lastAnsweredAt: z.string(),
});

export const AdvisersResponse = z.object({
  advisers: z.array(ListedAdviser),
  nextURLParam: NextURLParam,
});

export const AnswerWithAdviser = Answer.extend({
  adviser: Adviser,
});

export const QuestionAnswersResponse = z.object({
  answers: z.array(AnswerWithAdviser),
  nextURLParam: NextURLParam,
});

export const GetQuestionQuery = z.object({
  id: z.string(),
});

export const QuestionResponse = Question.extend({
  isOpenQuestion: z.boolean(),
  canAnswer: z.boolean(),
});

export const QuestionWithAnswerCount = Question.extend({
  answerCount: z.number(),
});

export const OpenQuestionsResponse = z.object({
  questions: z.array(QuestionWithAnswerCount),
  nextURLParam: NextURLParam,
});

export const QuestionWithAnswer = QuestionWithAnswerCount.extend({
  answers: z.array(Answer),
});

export const QuestionWithAnswers = QuestionWithAnswerCount.extend({
  answers: z.array(AnswerWithAdviser),
});

export const QuestionsResponse = z.object({
  q: z.string(),
  questions: z.array(QuestionWithAnswers),
  nextURLParam: NextURLParam,
});

export const AdviserResponseSchema = z.object({
  id: z.number(),
  userName: z.string(),
  twitterScreenName: z.string(),
  displayName: z.string(),
  workingAt: z.string(),
  offeredBy: z.string(),
  introduction: z.string(),
  isStudent: z.boolean(),
  iconImageURL: z.string(),
  backgroundImageURL: z.string(),
  industries: z.array(Industry),
  tags: z.array(BoxTagSchema),
  answerCount: z.number(),
  answerLikedCount: z.number(),
  createdAt: z.string(),
  lastAnsweredAt: z.string(),
  isInactivated: z.boolean(),
});

export const PostAdviserProfileDTO = z.object({
  workingAt: z.string(),
  offeredBy: z.string(),
  introduction: z.string(),
  tags: z.array(z.string()),
});

export const AdviserQuestionsResponse = z.object({
  questions: z.array(QuestionWithAnswer),
  nextURLParam: NextURLParam,
  prevNumber: z.number(),
  nextNumber: z.number(),
  questionID: z.number(),
  questionOrderType: z.string(),
});

export const PutTwitterTokenResponse = z.string();

export const AuthUrlResponse = z.object({
  url: z.string(),
});
